module.exports = __webpack_public_path__ + "d635e50bb6f072acc8de6f26629c2085.MP3";